import { render, staticRenderFns } from "./foldersSelectedEmployees.vue?vue&type=template&id=088d655f&scoped=true"
import script from "./foldersSelectedEmployees.vue?vue&type=script&lang=js"
export * from "./foldersSelectedEmployees.vue?vue&type=script&lang=js"
import style0 from "./foldersSelectedEmployees.vue?vue&type=style&index=0&id=088d655f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088d655f",
  null
  
)

export default component.exports